import { Service, type SWRConfiguration, useGet, useInfinite, useList, useRead } from "@api/common";
import type { ListParams, ReadParams, Thread, ThreadStats } from "./types";

export type { Thread, ThreadStats };

export class ThreadService extends Service<Thread> {
  constructor() {
    super("/threads");
  }
}

export const threadService = new ThreadService();

export function useThreads(params?: ListParams<Thread>, config?: SWRConfiguration) {
  return useList(threadService, params, config);
}

export function useThreadsInfinite(params?: ListParams<Thread>, config?: SWRConfiguration) {
  return useInfinite(
    threadService,
    { ...params, populate: "customer(firstName,lastName,phoneNumber)" },
    config,
  );
}

export function useThreadsStats(params?: ListParams<Thread>, config?: SWRConfiguration) {
  return useGet<ThreadStats>(threadService, `${threadService.basePath}/stats`, params, config);
}

export function useThread(id: string | undefined, params?: ReadParams, config?: SWRConfiguration) {
  return useRead(threadService, id, params, config);
}
